<div #group class="group">
  @if (groupIdActive !== null) {
    <od-chip [selected]="true" [showCross]="true" (crossClicked)="removeGroupClicked()">
      <span class="group-active">{{ groups.get(groupIdActive) }}</span>
    </od-chip>
  }
  <div class="group-btn" [class]="{'selected' : groupIdActive !== null, 'disabled' : loading}" (click)="toggleGroupMenu()">
    <span>Group</span>
    <od-svg-icon class="svg-wrapper group" [name]="'icon-group-' + groupActiveLabel"></od-svg-icon>
    <od-svg-icon class="svg-wrapper arrow" [name]="'icon-angle-' + groupMenuOpenIcon" [parentSize]="true"></od-svg-icon>
    @if (groupMenuOpen) {
      <div class="group-menu">
        <div class="group-block">
          @for (group of groups | keyvalue; track group) {
            <od-chip class="group-item" [selected]="group.key === groupIdActive" (click)="activeGroup(group.key)">{{ group.value }}</od-chip>
          }
        </div>
      </div>
    }
  </div>
</div>
